import styled from "@emotion/styled"

export const CheckboxInput = styled.input`
float: left;
margin: 5px;
`
export const CheckboxText = styled.div`
padding-left: 30px;
`